// J'importe tous les composants que nous avons créés, en .js
import { Navigation } from './components/Navigation.js';
import { HeroSection } from './components/HeroSection.js';
import { ServicesSection } from './components/ServicesSection.js';
import { PortfolioSection } from './components/PortfolioSection.js';
import { AboutSection } from './components/AboutSection.js';
import { ProcessSection } from './components/ProcessSection.js';
// J'importe notre composant de contact/footer
import { ContactAndFooter } from './components/ContactAndFooter.js';

// Le 'export default' fonctionne parfaitement en JS
export default function App() {
  return (
    // J'ai gardé les classes de base
    <div className="min-h-screen bg-background">
      {/* 1. Navigation */}
      <Navigation />

      {/* 2. Contenu principal */}
      <main>
        {/* 3. Hero Section */}
        <HeroSection />

        {/* 4. Services Section */}
        <ServicesSection />

        {/* 5. Portfolio (Domaines) Section */}
        <PortfolioSection />

        {/* 6. About (Engagements) Section */}
        <AboutSection />

        {/* 7. Process (Méthode) Section */}
        <ProcessSection />

        {/* 8. Contact & Footer (notre composant combiné) */}
        <ContactAndFooter />
      </main>
    </div>
  );
}
